require('./blocks/big-action.less');
require('./blocks/product/product');
require('./blocks/catalog.less');
require('./blocks/pagination.less');
require('./blocks/benefits/benefits');
require('./blocks/benefit.less');
require('./blocks/seo-text.less');
require('./blocks/catalog');
require('./blocks/filter-price/filter-price.less');
require('./blocks/filter/filter.less');
require('./blocks/news/news.less');



// WEBPACK FOOTER //
// ./sale_and_promo.js